import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutMe from './pages/AboutMe';
import ContactMe from './pages/ContactMe';
import Services from './pages/Services';
import BookConsultation from './pages/BookConsultation';
import ADACompliant from './pages/ADACompliant';
import Accessibility from './pages/Accessibility';
import Offers from './pages/Offers';
import CustomSoftware from './pages/CustomSoftware';

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/contactme" element={<ContactMe />} />
          <Route path="/services" element={<Services />} />
          <Route path="/book" element={<BookConsultation />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/custom-software" element={<CustomSoftware />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/ada-compliant" element={<ADACompliant />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
